import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { PawPrint } from 'lucide-react';
export type Pet = {
  id: string;
  name: string;
  breed: string;
  bio: string;
  imageUrl: string;
  huellas: number;
};
type PetCardProps = {
  pet: Pet;
  index: number;
  hasVoted: boolean;
  onVote: (id: string) => void;
};
export function PetCard({
  pet,
  index,
  hasVoted,
  onVote
}: PetCardProps) {
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.4,
    delay: Math.min(index, 8) * 0.04,
    ease: [0.22, 1, 0.36, 1]
  }} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-lg transition-shadow flex flex-col h-full" data-id="element-660" data-mp="j1omwomet4ed">
      <div className="relative w-full bg-gray-100 flex-shrink-0" style={{
      aspectRatio: '1 / 1'
    }} data-id="element-661" data-mp="5os7621rmr3">
        {pet.imageUrl ? <img src={pet.imageUrl} alt={pet.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover" data-id="element-662" data-mp="253l610mj8jnm" /> : <div className="absolute inset-0 flex items-center justify-center text-gray-300" data-id="element-663" data-mp="2e5avi0wut8ir">
            <PawPrint className="w-10 h-10" data-id="element-664" data-mp="29818erwxt8y3" />
          </div>}
      </div>

      <div className="p-2.5 md:p-4 flex flex-col gap-2 flex-grow" data-id="element-665" data-mp="1lgdsf517rial">
        <div className="min-w-0 h-9 md:h-11" data-id="element-666" data-mp="1hfk44ajv01h6">
          <h3 className="font-bold text-brand-navy text-sm md:text-base truncate leading-tight" data-id="element-667" data-mp="1hgv3ly69un2h">
            {pet.name}
          </h3>
          <p className="text-xs text-gray-500 truncate leading-tight" data-id="element-668" data-mp="1v8t7nul4lsrs">
            {pet.breed || '\u00A0'}
          </p>
        </div>

        <button type="button" onClick={() => onVote(pet.id)} disabled={hasVoted} aria-label={hasVoted ? `Ya le diste tu huella a ${pet.name}` : `Dar una huella a ${pet.name}`} className={`mt-auto inline-flex items-center justify-center gap-1.5 w-full px-3 py-2 rounded-full font-bold text-xs md:text-sm transition-all ${hasVoted ? 'bg-brand-green/10 text-brand-green cursor-default' : 'bg-brand-cyan text-white hover:bg-blue-700'}`} data-id="element-669" data-mp="12q5owltlqptv">
          <PawPrint className={`w-4 h-4 ${hasVoted ? 'fill-brand-green' : ''}`} data-id="element-670" data-mp="3chx7dr6ppygv" />
          <span data-id="element-671" data-mp="2ewswsy312oon">{pet.huellas}</span>
          <span className="hidden sm:inline" data-id="element-672" data-mp="2jtsyyxwrb7ah">
            {hasVoted ? 'Huella dada' : 'Dar Huella'}
          </span>
        </button>
      </div>
    </motion.article>;
}